import { useState, useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"

const useSupplierDocumentStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('supplier_document_statuses_last_updated', 0)
    const [supplierDocumentStatuses, setSupplierDocumentStatuses] = useLocalStorage('supplier_document_statuses', [])
    
    useEffect(() => {
        if( supplierDocumentStatuses.length === 0 ) {
            reload()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reload()
    }, [])

    const reload = () => {
        setLastUpdated(Date.now())
        fetch('/v0/supplier_document_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                const statuses = json.results
                setSupplierDocumentStatuses(statuses)
            })
            .catch(error => {
                console.log("SupplierDocumentStatuses reload error", error)
            })
    }

    return {
        supplierDocumentStatuses,
    }
}

export default useSupplierDocumentStatuses
